import React from "react";
import { useTheme } from "react-jss";
import useStyles from "./OpenEndRenderer.styles";
import { RendererProps } from "../BaseRenderer";
import { ValidationResultModel } from "../../../models/ValidationResultModel";
import InputBox from "../../shared/InputBox";

interface Props extends RendererProps {
    value?: string;
    name?: string;
    label?: string;
    isDisabled?: boolean;
    isDisabledRequest?: boolean;
    isHidden?: boolean;
    onOpenEndChange?: React.ChangeEventHandler;
    onOpenEndBlur?: React.FocusEventHandler;
    openEndChoiceId?: string;
    openEndType?: string;
    validationResult?: ValidationResultModel;
    size?: string;
    lines?: number;
    style?: any;
    isMouseDownEventPropagation?: boolean;
    isClickEventPropagation?: boolean;
}

export default function OpenEndRenderer(props: Props) {
    const {
        isDisabledRequest,
        isDisabled,
        isHidden,
        onOpenEndBlur,
        onOpenEndChange,
        name,
        value,
        label,
        size,
        lines,
        gridRendering,
        style,
        isMouseDownEventPropagation = false,
        isClickEventPropagation = false,
    } = props;

    const [focused, setFocused] = React.useState(false);
    const theme = useTheme();
    const classes = useStyles({ theme, size, gridRendering });

    if (isHidden && !isDisabledRequest) return null;

    return (
        // Wrapper to keep open ends text color when rendering open end inside choices
        <div className={classes.openEnd}>
            <InputBox focused={focused} freeform size="Full">
                <textarea
                    id={`${name}_OE_INPUT`}
                    name={`${name}_OE`}
                    aria-label={label}
                    value={value}
                    onChange={onOpenEndChange}
                    rows={lines}
                    onMouseDown={(e) => {
                        if (!isMouseDownEventPropagation) {
                            e.stopPropagation();
                        }
                    }}
                    onClick={(e) => {
                        // eslint-disable-next-line no-undef
                        if (!isClickEventPropagation) {
                            e.stopPropagation();
                        }
                    }}
                    onFocus={() => {
                        setFocused(true);
                    }}
                    onBlur={(e) => {
                        setFocused(false);
                        onOpenEndBlur(e);
                    }}
                    disabled={isDisabled}
                    style={style}
                />
            </InputBox>
        </div>
    );
}
